






import Vue from 'vue';
import ErrorHint from './ErrorHint.vue';
export default Vue.extend({
    components: { ErrorHint },
    props: {
        errors: {
            type: [Array],
            default: () => [],
        },
    },
});
